module.exports = __webpack_public_path__ + "drop-menu-s-white.e2c22b2ab41fb959ab8c32a81ac5a398.png";